import type {ReactElement} from 'react';
import React, { useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import styles from './icon-dropdown-group.module.scss';

export interface IconDropdownGroupProps {
  id: string;
  className?: string;
  icon: string;
  isIconSelected?: boolean;
  dropdownIcon?: string;
  dropdownPopup: ReactElement<any>;
  dropdownClassName?: string;
  alignment?: ALIGNMENT_TYPE;

  onClickDropdownSelector?(isOpened?: boolean): void;

  onClickIcon?(): void;
  leftOffset?: number;
}

export function IconDropdownGroup({
  className = '',
  dropdownClassName = '',
  alignment = ALIGNMENT_TYPE.BOTTOM_END,
  onClickIcon = (): void => {},
  isIconSelected = false,
  leftOffset = 0,
  ...props
}: IconDropdownGroupProps): ReactElement<any> {
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);

  const getDropdownSelector = (): ReactElement<any> => {
    return (
      <div className={`${styles.dropdownSelectorContainer} flex-center ${isDropdownOpened ? styles.selectedDropdownSelector : ''}`}>
        <Icon icon="icon-caret-down" size={IconSize.SIZE_ICON_20} />
      </div>
    );
  };

  return (
    <div id={props.id} className={`${styles.container} ${className} flex-row-align-center`}>
      <div className={`${styles.iconContainer} ${isIconSelected ? styles.selectedIconContainer : ''}`} onClick={onClickIcon}>
        <Icon icon={props.icon} size={IconSize.SIZE_ICON_20} />
      </div>
      <Dropdown
        alignment={alignment}
        popUpHasCustomWidth
        selector={getDropdownSelector()}
        onOpen={(): void => {
          setIsDropdownOpened(true);
        }}
        onClose={(): void => {
          setIsDropdownOpened(false);
        }}
        popup={props.dropdownPopup}
        className={dropdownClassName}
        leftOffset={leftOffset}
        popupClassName="border-s-standard"
      />
    </div>
  );
}
